import React, { useState, useEffect } from "react";
import { Container, Form, Card, Alert } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import RainbowButton from "../shared/RainbowButton";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { pageMeta } from "../../config/helmetConfig";
import { updateMetaTags } from "../../utils/metaManager";

export default function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [validated, setValidated] = useState(false);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const { login, currentUser, error } = useAuth();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    updateMetaTags(pageMeta.admin);
  }, []);

  useEffect(() => {
    // Check if redirected due to expired token
    if (searchParams.get("expired") === "true") {
      setMessage("Your session has expired. Please log in again.");
    }
  }, [searchParams]);

  useEffect(() => {
    // If user is already logged in, redirect to admin dashboard
    if (currentUser) {
      navigate("/admin/dashboard");
    }
  }, [currentUser, navigate]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
      return;
    }

    setValidated(true);
    setLoading(true);
    setMessage(""); // Clear any previous messages

    // Call the login function from our auth context
    const success = await login(username, password);

    setLoading(false);

    if (success) {
      navigate("/admin/dashboard");
    }
  };

  return (
    <Container className="d-flex align-items-center justify-content-center">
      <Card
        style={{ width: "100%", maxWidth: "450px" }}
        className="shadow my-5 bg-dark text-white"
      >
        <Card.Body className="p-5">
          <div className="text-center mb-4">
            <h2 className="fw-bold">Login</h2>
          </div>

          {/* Display either error from auth context or custom message */}
          {(error || message) && (
            <Alert
              variant="danger"
              onClose={() => {
                if (message) setMessage("");
                // Clear error state if needed
              }}
              dismissible
            >
              {message || error}
            </Alert>
          )}

          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="formBasicUsername">
              <Form.Label>Username</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
              />
              <Form.Control.Feedback type="invalid">
                Please provide a valid username.
              </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-4" controlId="formBasicPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                minLength="6"
              />
              <Form.Control.Feedback type="invalid">
                Password must be at least 6 characters.
              </Form.Control.Feedback>
              <div className="d-flex justify-content-end mt-2">
                <a
                  href="#forgot-password"
                  className="text-decoration-none small"
                >
                  Forgot password?
                </a>
              </div>
            </Form.Group>
            <div className="text-center">
              <RainbowButton
                text={loading ? "Signing In..." : "Sign In"}
                type="submit"
                disabled={loading}
              />
            </div>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  );
}
